<mat-card>
  <mat-horizontal-stepper #stepper>
    <mat-step label="{{ settings.lang.selectExcelFile }}">
      <h3>{{ settings.lang.selectExcelFile }}</h3>
      <input type="file" (change)="fileChange($event)" />
    </mat-step>
    <mat-step label="{{ settings.lang.mapExcelColumns }}">
      <ng-container *ngIf="filename">
        <button (click)="loadSettings()" mat-raised-button>
          {{ settings.lang.loadExcelSettings }}
        </button>
        <button (click)="saveSettings()" mat-raised-button>
          {{ settings.lang.saveExcelSettings }}
        </button>
        <button (click)="testImport()" mat-raised-button color="accent">
          {{ settings.lang.nextStep }}
        </button>

        <h3>{{ settings.lang.addColumnsThatAreNotInTheFile }}</h3>

        <ul>
          <li *ngFor="let ac of additionalColumns; let i = index">
            <select [(ngModel)]="ac.column">
              <option value="">{{ settings.lang.excelColumnIgnore }}</option>
              <option *ngFor="let c of columns" [ngValue]="c">
                {{ c.name }}
              </option>
            </select>
            <input [(ngModel)]="ac.value" />
            <button (click)="additionalColumns.splice(i, 1)">
              {{ settings.lang.remove }}
            </button>
          </li>
        </ul>
        <button (click)="additionalColumns.push({})" mat-raised-button>
          {{ settings.lang.addExcelColumn }}
        </button>

        <h3>{{ settings.lang.mapExcelColumns }}</h3>

        <div class="table-div">
          <table class="table table-bordered">
            <tr>
              <th>#</th>

              <th *ngFor="let ec of excelColumns">
                {{ ec.title }}
                <br />
                <select [(ngModel)]="ec.column">
                  <option value="">
                    {{ settings.lang.excelColumnIgnore }}
                  </option>
                  <option *ngFor="let c of columns" [ngValue]="c">
                    {{ c.name }}
                  </option>
                </select>
              </th>
            </tr>
            <ng-container *ngFor="let r of rows">
              <tr>
                <td>{{ r }}</td>

                <td *ngFor="let c of excelColumns">
                  {{ getTheData(c.excelColumn + r) }}
                </td>
              </tr>
            </ng-container>
          </table>
        </div>

        >{{ settings.lang.total }} {{ rows.length }}
        {{ settings.lang.linesInExcel }}
      </ng-container>
    </mat-step>
    <mat-step label="{{ settings.lang.executeExcelImport }}">
      <h3>{{ settings.lang.excelImportResults }}</h3>
      <mat-tab-group>
        <mat-tab
          label="{{ settings.lang.newVolunteers }} - {{ newRows.length }}"
          *ngIf="newRows && newRows.length"
        >
          <div class="table-div">
            <table class="table table-bordered" style="white-space: nowrap">
              <tr>
                <th></th>
                <th></th>
                <th *ngFor="let c of columnsInCompare">
                  {{ c.caption }}
                </th>
              </tr>
              <ng-container *ngFor="let i of newRows">
                <tr>
                  <td>
                    <mat-icon
                      style="color: red"
                      (click)="newRows.splice(newRows.indexOf(i), 1)"
                    >
                      delete_forever</mat-icon
                    >
                  </td>
                  <td>{{ i.rowInExcel }}<br /></td>
                  <td *ngFor="let c of columnsInCompare">
                    {{ getColInfo(i, c).newDisplayValue }}
                  </td>
                </tr>
              </ng-container>
            </table>
          </div>

          <button (click)="addAll()" mat-raised-button color="accent">
            {{ settings.lang.addAllVolunteers }}
          </button>
        </mat-tab>
        <mat-tab
          label="{{ settings.lang.updateVolunteers }} - {{ updateRows.length }}"
          *ngIf="updateRows && updateRows.length"
        >
          <div class="table-div">
            <table class="table table-bordered" style="white-space: nowrap">
              <tr>
                <th></th>
                <th></th>
                <th *ngFor="let c of columnsInCompare">
                  {{ c.caption }}
                  <mat-icon
                    style="color: green"
                    *ngIf="getColUpdateCount(c) > 0"
                    (click)="updateAllCol(c)"
                    >done_all
                  </mat-icon>
                </th>
              </tr>
              <ng-container *ngFor="let i of updateRows">
                <tr>
                  <td>
                    <mat-icon
                      style="color: red"
                      (click)="updateRows.splice(updateRows.indexOf(i), 1)"
                    >
                      remove_circle_outline</mat-icon
                    >
                  </td>
                  <td>{{ i.rowInExcel }}<br /></td>
                  <td *ngFor="let c of columnsInCompare">
                    <span
                      [class.newValue]="
                        i.duplicateHelperInfo &&
                        i.duplicateHelperInfo.length == 1 &&
                        getColInfo(i, c).newDisplayValue !=
                          getColInfo(i, c).existingDisplayValue
                      "
                    >
                      {{ getColInfo(i, c).newDisplayValue }}</span
                    >
                    <ng-container
                      *ngIf="
                        i.duplicateHelperInfo &&
                        i.duplicateHelperInfo.length == 1 &&
                        getColInfo(i, c).newDisplayValue !=
                          getColInfo(i, c).existingDisplayValue
                      "
                    >
                      <br /><span
                        style="color: red; text-decoration-line: line-through"
                        >{{ getColInfo(i, c).existingDisplayValue }}</span
                      >
                      <mat-icon
                        style="color: red"
                        (click)="clearColumnUpdate(i, c)"
                        >close
                      </mat-icon>
                      <mat-icon style="color: green" (click)="updateCol(i, c)"
                        >done</mat-icon
                      >
                    </ng-container>
                  </td>
                </tr>
              </ng-container>
            </table>
          </div>
        </mat-tab>
        <mat-tab
          label="{{ settings.lang.existingVolunteers }} - {{
            identicalRows.length
          }}"
          *ngIf="identicalRows && identicalRows.length"
        >
          <div class="table-div">
            <table class="table table-bordered" style="white-space: nowrap">
              <tr>
                <th></th>
                <th *ngFor="let c of columnsInCompare">
                  {{ c.caption }}
                </th>
              </tr>
              <ng-container *ngFor="let i of identicalRows">
                <tr>
                  <td>{{ i.rowInExcel }}<br /></td>
                  <td *ngFor="let c of columnsInCompare">
                    {{ getColInfo(i, c).newDisplayValue }}
                  </td>
                </tr>
              </ng-container>
            </table>
          </div>
        </mat-tab>
        <mat-tab
          label="{{ settings.lang.errors }} -  {{ errorRows.length }}"
          *ngIf="errorRows && errorRows.length"
        >
          <div class="table-div">
            <table class="table table-bordered" style="white-space: nowrap">
              <tr>
                <th></th>
                <th *ngFor="let c of columnsInCompare">
                  {{ c.caption }}
                </th>
              </tr>
              <ng-container *ngFor="let i of errorRows">
                <tr>
                  <td>{{ i.rowInExcel }}<br /></td>
                  <td *ngFor="let c of columnsInCompare">
                    {{ getColInfo(i, c).newDisplayValue }}
                  </td>
                </tr>
                <tr>
                  <td colspan="10" style="color: red">
                    {{ i.error }}

                    <ul
                      *ngIf="
                        i.duplicateHelperInfo &&
                        i.duplicateHelperInfo.length >= 1
                      "
                    >
                      <li *ngFor="let f of i.duplicateHelperInfo">
                        {{ f.name }} - {{ displayDupInfo(f) }}
                      </li>
                    </ul>
                    <a (click)="moveFromErrorToAdd(i)">{{
                      settings.lang.moveToNewVolunteers
                    }}</a>
                  </td>
                </tr>
              </ng-container>
            </table>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-step>
  </mat-horizontal-stepper>
</mat-card>
